/* eslint-disable yola/react/require-default-props */
import React, { useCallback, forwardRef } from 'react';
import { useController } from 'react-hook-form';
import SearchableSelect from '../searchable-select';
import FieldStatus from '../field-status';
import noop from '../../../utils/noop';

const defaultRules = {};
const defaultOptions = [];

const SearchableSelectField = forwardRef(
  (
    {
      name,
      options = defaultOptions,
      control,
      rules = defaultRules,
      placeholder = '',
      onChange = noop,
      onBlur = noop,
      ...otherProps
    },
    ref
  ) => {
    const { field, fieldState } = useController({
      name,
      control,
      rules,
    });

    const handleChange = useCallback(
      (option) => {
        const value = option ? option.value : null;

        field.onChange(value);
        if (onChange) onChange(value);
      },
      [field, onChange]
    );

    const handleBlur = useCallback(() => {
      field.onBlur();
      if (onBlur) onBlur();
    }, [field, onBlur]);

    let defaultValue = options.find(({ value }) => value === field.value);

    if (!defaultValue && !placeholder) {
      [defaultValue] = options;
    }

    return (
      <React.Fragment>
        <SearchableSelect
          {...otherProps}
          ref={ref}
          onChange={handleChange}
          onBlur={handleBlur}
          options={options}
          defaultValue={defaultValue}
          placeholder={placeholder}
          name={field.name}
          invalid={fieldState.invalid}
        />
        {fieldState.error && <FieldStatus appearance="error" text={fieldState.error.message} />}
      </React.Fragment>
    );
  }
);

SearchableSelectField.displayName = 'SearchableSelectField';

export default SearchableSelectField;
